import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/safiruni/front/app/[lang]/faculities/FaculitiesClient.tsx");
